import React, { useState, useEffect } from "react";
import { Row, Col, Card, Skeleton, Divider, Empty } from "antd";
import { Link } from "react-router-dom";
import { gql, useLazyQuery } from "@apollo/client";
import { apiUrl } from "@utils/apoloClient";
import StrikethroughPrice from "@general/strikethroughPrice";
import OtherErrors from "@general/otherErrors";

const UserClasses = ({ colSpan }) => {
  const [classesDetails, setClassesDtails] = useState([]);
  const cardColSpan = colSpan || { xl: 6, lg: 8, sm: 12, xs: 24 };

  const GETCLASSES = gql`
    query ($paginateInput: PaginateInput!, $searchInput: ProductSearchInput!) {
      getProducts(paginateInput: $paginateInput, searchInput: $searchInput) {
        id
        name
        image
        capacity
        amountRial
        strikethroughRial
      }
    }
  `;
  const [getClasses, classes] = useLazyQuery(GETCLASSES, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setClassesDtails(data?.getProducts);
    },
    onError(err) {
      console.log("Error while fetching Classes: ", err);
    },
  });

  useEffect(() => {
    getClasses({
      variables: {
        paginateInput: {
          page: 1,
          perPage: 100,
        },
        searchInput: {
          category: ["CLASS"],
        },
      },
    });
  }, []);

  const style = {
    card: {
      width: 240,
      minHeight: 320,
      display: "block",
      margin: "auto",
    },
    title: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "15px",
    },
  };

  if (classes.loading) {
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  }

  if (classes.error) {
    return <OtherErrors />;
  }

  if (classesDetails?.length) {
    return (
      <Row
        gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 50]}
        align="middle"
      >
        <Divider
          orientation="right"
          style={{ fontSize: "15px", fontWeight: "bold" }}
        >
          دوره‌های آموزشی
        </Divider>
        {classesDetails?.map((classUnit) => {
          return (
            <Col key={classUnit?.id} {...cardColSpan}>
              <Link to={`/classes/classes-single/${classUnit?.id}`}>
                <Card
                  hoverable
                  style={style.card}
                  cover={
                    <img alt="safatec" src={`${apiUrl + classUnit?.image}`} />
                  }
                >
                  <p style={style.title}>{classUnit?.name}</p>
                  <span className="card-row">
                    <p>ظرفیت: </p> <span>{`${classUnit?.capacity} نفر`}</span>
                  </span>
                  <StrikethroughPrice
                    strikethroughRial={classUnit?.strikethroughRial}
                    amountRial={classUnit?.amountRial}
                  />
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    );
  }

  return (
    <div>
      <Divider
        orientation="right"
        style={{ fontSize: "15px", fontWeight: "bold" }}
      >
        دوره‌های آموزشی
      </Divider>
      <Empty description="در حال حاضر دوره آموزشی فعالی موجود نیست!" />
    </div>
  );
};

export default UserClasses;
